const dims = {
  appBarHeight: "64px",
  drawerOpenedW: "180px",
  drawerClosedW: "0px",
  drawerOpenedBorder: "1px solid #e0e0e0",
  drawerClosedBorder: "none",
};

export default dims;
